let logId = 0
let logs = []
let subscribers = []

export const logger = {
  logs: () => logs,
  
  subscribe: (callback) => {
    subscribers.push(callback)
    callback(logs)
    
    return () => {
      subscribers = subscribers.filter(sub => sub !== callback)
    }
  },
  
  log: (level, message, data = {}) => {
    const logEntry = {
      id: ++logId,
      level,
      message,
      timestamp: Date.now(),
      type: level,
      ...data
    }
    
    logs.push(logEntry)
    
    // Keep only last 100 logs
    if (logs.length > 100) {
      logs = logs.slice(-100)
    }
    
    // Notify subscribers
    subscribers.forEach(callback => callback([...logs]))
    
    // Also log to console for development
    console[level] || console.log(message, data)
    
    return logEntry
  },
  
  info: (message, data) => logger.log('info', message, data),
  warn: (message, data) => logger.log('warn', message, data),
  error: (message, data) => logger.log('error', message, data),
  success: (message, data) => logger.log('success', message, data),
  
  // API-specific logging methods
  logRequest: (api, method, url, requestData = {}) => {
    return logger.log('info', `${method} ${url}`, {
      api,
      method,
      url,
      request: requestData,
      type: 'request'
    })
  },
  
  logResponse: (logId, status, responseData, duration = 0, headers = {}) => {
    const existingLog = logs.find(log => log.id === logId)
    if (existingLog) {
      existingLog.status = status
      existingLog.response = responseData
      existingLog.duration = duration
      existingLog.headers = headers
      existingLog.type = status >= 400 ? 'error' : 'success'
      
      // Notify subscribers of the update
      subscribers.forEach(callback => callback([...logs]))
    }
  },
  
  logError: (logId, error, status = 0) => {
    const existingLog = logs.find(log => log.id === logId)
    if (existingLog) {
      existingLog.error = error.message || error
      existingLog.status = status || 500
      existingLog.type = 'error'
      
      // Notify subscribers of the update
      subscribers.forEach(callback => callback([...logs]))
    } else {
      // Create new error log if no existing log found
      logger.error('API Error', {
        error: error.message || error,
        status: status || 500
      })
    }
  },
  
  clear: () => {
    logs = []
    subscribers.forEach(callback => callback([]))
  }
}